import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BECSECyberSecurityCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. CSE (Cyber Security)",
    shortName: "B.E. CSE (Cyber)",
    duration: "4 years", 
    description: "Specialized computer science program focused on cybersecurity, ethical hacking, and information security",
    overview: "Bachelor of Engineering in Computer Science and Engineering with specialization in Cyber Security (B.E. CSE Cyber Security) is a 4-year undergraduate program that combines core computer science principles with advanced cybersecurity concepts. This course prepares students to protect digital infrastructure, prevent cyber attacks, and ensure information security in the digital age.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Strong logical thinking and problem-solving skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II", 
          "Physics",
          "Chemistry",
          "Programming in C",
          "Digital Logic Design",
          "Computer Fundamentals"
        ]
      },
      {
        year: 2,
        subjects: [
          "Data Structures and Algorithms",
          "Computer Networks",
          "Operating Systems",
          "Database Management Systems", 
          "Discrete Mathematics",
          "Information Security Fundamentals"
        ]
      },
      {
        year: 3,
        subjects: [
          "Network Security",
          "Cryptography",
          "Ethical Hacking",
          "Digital Forensics",
          "Web Application Security",
          "Malware Analysis"
        ]
      },
      {
        year: 4,
        subjects: [
          "Advanced Cybersecurity",
          "Incident Response",
          "Security Auditing",
          "Blockchain Security",
          "Cybersecurity Project",
          "Industry Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Cybersecurity Analyst",
        "Information Security Officer",
        "Ethical Hacker/Penetration Tester",
        "Security Consultant",
        "Digital Forensics Investigator", 
        "Security Architect",
        "Incident Response Specialist",
        "Compliance Officer"
      ],
      industries: [
        "IT Security Companies",
        "Banking and Financial Services",
        "Government and Defense",
        "Healthcare Organizations",
        "Consulting Firms",
        "Technology Companies",
        "Law Enforcement",
        "Critical Infrastructure"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹15-35 LPA (Experienced)",
      topRecruiters: [
        "Cisco, Palo Alto Networks",
        "IBM Security, Microsoft",
        "Deloitte, KPMG, EY",
        "TCS, Infosys, Wipro",
        "CyberArk, FireEye",
        "Government Agencies"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Indian Institute of Information Technology, Allahabad",
        location: "Allahabad",
        fees: "₹5,85,000",
        ranking: "NIRF Ranking: 45"
      },
      {
        name: "Vellore Institute of Technology",
        location: "Chennai", 
        fees: "₹1,98,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "SSN College of Engineering",
        location: "Chennai",
        fees: "₹4,20,000",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹2,50,000",
        ranking: "NAAC A++ Grade"
      }
    ],

    skills: [
      "Network Security",
      "Ethical Hacking",
      "Cryptography",
      "Risk Assessment",
      "Digital Forensics",
      "Security Tools (Wireshark, Metasploit)",
      "Incident Response",
      "Compliance and Auditing",
      "Problem Solving",
      "Communication Skills"
    ],

    futureScope: "Extremely high demand due to increasing cyber threats, with opportunities in emerging areas like IoT security, cloud security, and AI-powered cybersecurity.",

    faqs: [
      {
        question: "Is Cyber Security only about hacking?",
        answer: "No, cybersecurity involves protecting systems, networks, and data. It includes risk assessment, policy development, compliance, and incident response beyond just ethical hacking."
      },
      {
        question: "Do I need prior programming experience?",
        answer: "While not mandatory, basic programming knowledge helps. The course covers programming from fundamentals with a security focus."
      },
      {
        question: "Are there good career prospects?",
        answer: "Excellent! Cybersecurity is one of the fastest-growing fields with a massive skill shortage and high-paying opportunities."
      },
      {
        question: "Can I get certifications during the course?",
        answer: "Yes, many colleges encourage industry certifications like CEH, CISSP, CISA which enhance employability significantly."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BECSECyberSecurityCoursePage;
